import React from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";
import { FileText, Image, Inbox, HelpCircle, BookOpen, Newspaper, ArrowUpRight } from "lucide-react";

const Card = ({ to, icon: Icon, label, value, testid }) => (
  <Link to={to} data-testid={testid} className="admin-card p-6 group hover:bg-[var(--ink)] hover:text-white transition-colors">
    <div className="flex items-center justify-between mb-6">
      <Icon size={18} />
      <ArrowUpRight size={16} className="opacity-50 group-hover:opacity-100" />
    </div>
    <div className="font-cond text-5xl font-black leading-none">{value}</div>
    <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-70 mt-2">{label}</div>
  </Link>
);

export default function Dashboard() {
  const [stats, setStats] = React.useState({});
  React.useEffect(() => {
    Promise.all([api.adminPages(), api.adminMedia(), api.adminFaq(), api.adminGloss(), api.adminNews(), api.submissions()])
      .then(([pages, media, faq, gloss, news, subs]) => setStats({
        pages: pages.length, media: media.length, faq: faq.length, gloss: gloss.length, news: news.length, subs: subs.length, newSubs: subs.filter(s => s.status === "new").length,
      }));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-10">
        <div className="brut-tag mb-4">CMS / DASHBOARD</div>
        <h1 className="brut-h1">Willkommen zurück.</h1>
        <p className="brut-body mt-4 max-w-2xl opacity-80">Alle Inhalte, Medien und Anfragen an einem Ort. Änderungen werden sofort live, Design bleibt geschützt.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        <Card to="/admin/pages" icon={FileText} label="Seiten" value={stats.pages ?? "—"} testid="dash-pages" />
        <Card to="/admin/media" icon={Image} label="Medien" value={stats.media ?? "—"} testid="dash-media" />
        <Card to="/admin/faq" icon={HelpCircle} label="FAQ" value={stats.faq ?? "—"} testid="dash-faq" />
        <Card to="/admin/glossary" icon={BookOpen} label="Glossar" value={stats.gloss ?? "—"} testid="dash-glossary" />
        <Card to="/admin/news" icon={Newspaper} label="News" value={stats.news ?? "—"} testid="dash-news" />
        <Card to="/admin/submissions" icon={Inbox} label={`Anfragen (${stats.newSubs ?? 0} neu)`} value={stats.subs ?? "—"} testid="dash-submissions" />
      </div>
    </div>
  );
}
